<fc-search-input
  [label]="'MAINTENANCE_TYPE.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayText]="displayText"
  [displayWith]="displayWith"
  [legacyStyle]="legacyStyle"
  [isDuplicatedForm]="isDuplicatedForm"
  [showAllOption]="showAllMaintenanceTypesOption"
  [showAllOptionText]="'MAINTENANCE_TYPE.SELECT_ALL' | translate"
  [options]="options"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [translateErrorPrefix]="translateErrorPrefix"
></fc-search-input>
